import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const MedicalWebsiteFeatures = () => {
  const relatedBlogs = [
   {
      id: 7,
      title: 'Patient Acquisition Strategies That Work in 2026',
      image: '/images/Blog9.png',
      date: 'February 1, 2026'
    },
    {
      id: 1,
      title: 'How to Optimize Your Medical Practice Website for Local SEO in 2026',
      image: '/images/Blog4.png',
      date: 'February 3, 2026'
    },
    {
      id: 11,
      title: 'Essential Features Every Medical Practice Website Needs in 2026',
      image: '/images/Blog13.png',
      date: 'January 22, 2026'
    }
  ];

  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/* HERO SECTION */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1547658719-da2b51169166?w=1920&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        <div className="relative z-10 text-center px-4 sm:px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 sm:mb-8"
          >
            Medical Website Features
          </motion.h1>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Home
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <Link 
              to="/blog" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Blog
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <span className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold text-sm sm:text-base">
              Website Conversion
            </span>
          </motion.div>
        </div>
      </section>

      {/* SECTION 1: TWO-COLUMN WITH SIDEBAR */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          <div className="grid lg:grid-cols-12 gap-6 lg:gap-8">
            
            {/* LEFT SIDE - Intro Content */}
            <div className="lg:col-span-8">
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="mb-8"
              >
                <img 
                  src="/images/Blog13.png" 
                  alt="Website Conversion"
                  className="w-full rounded-2xl"
                />
              </motion.div>

              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#19354a] mb-6"
              >
                Essential Features Every Medical Practice Website Needs in 2026
              </motion.h1>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="flex flex-wrap items-center gap-4 text-sm text-[#19354a] mb-8 pb-6 border-b-2 border-gray-200"
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                  </svg>
                  <span>Docmize Team</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span>Published : January 22, 2026</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span>Last Updated : January 22, 2026</span>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                  Converting website visitors into booked appointments represents the ultimate measure of healthcare website effectiveness. While attracting traffic requires strong SEO and marketing, conversion optimization ensures that visitors take desired actions—scheduling appointments, requesting consultations, or contacting your practice. In 2026, successful medical practices combine user experience optimization, persuasive design, and data-driven testing to maximize conversion rates and patient acquisition.
                </p>

                <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                  This comprehensive guide explores proven tactics for optimizing healthcare website conversion rates. From booking process simplification and trust signal enhancement to call-to-action optimization and friction reduction, learn how to implement conversion strategies that transform website visitors into scheduled patients while maintaining professional standards and HIPAA compliance.
                </p>
              </motion.div>

            </div>

            {/* RIGHT SIDE - Sidebar */}
            <motion.aside 
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="lg:col-span-4"
            >
              <div className="sticky top-24">
                
                <div className="bg-white rounded-2xl border-2 border-[#19354a] p-6 mb-6">
                  <h3 className="text-xl font-bold text-[#19354a] mb-6 pb-4 border-b-2 border-gray-200">
                    Categories
                  </h3>
                  <div className="space-y-2">
                    {['Patient Acquisition', 'Web Development', 'Digital Marketing', 'SEO', 'Healthcare Technology', 'Content Marketing', 'Social Media', 'Online Reputation Management'].map((category, index) => (
                      <Link
                        key={index}
                        to="/blog"
                        className="w-full text-left px-4 py-3 rounded-lg font-medium transition-all bg-gray-50 text-gray-700 hover:bg-[#19354a] hover:text-white block"
                      >
                        <div className="flex items-center justify-between">
                          <span>{category}</span>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>

                <div className="bg-gradient-to-br from-[#19354a] to-[#0f2133] rounded-2xl p-6 text-white">
                  <h3 className="text-xl font-bold mb-4">
                    Need Help Optimizing Conversions?
                  </h3>
                  <p className="text-white/80 mb-6 text-sm leading-relaxed">
                    Get expert conversion optimization strategies for your medical practice website.
                  </p>
                  <Link 
                    to="/contact"
                    className="block w-full text-center px-6 py-3 bg-[#39a5d3] text-white rounded-lg font-semibold hover:bg-white hover:text-[#19354a] transition-all"
                  >
                    Get Free Consultation
                  </Link>
                </div>

              </div>
            </motion.aside>

          </div>
        </div>
      </section>

      {/* SECTION 2: FULL WIDTH CONTENT */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Understanding Healthcare Website Conversion
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Conversion rate optimization (CRO) focuses on increasing the percentage of website visitors who complete desired actions. For medical practices, primary conversions include appointment bookings, consultation requests, phone calls, and contact form submissions. Successful conversion optimization requires understanding patient behavior, removing obstacles, building trust, and creating compelling reasons to take action.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Average healthcare website conversion rates range from 2-5%, meaning 95-98% of visitors leave without taking action. Strategic optimization can double or triple conversion rates, dramatically increasing patient acquisition without increasing traffic. Even small improvements generate significant impact—improving conversion from 2% to 4% doubles appointment bookings from the same traffic volume.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Optimizing the Booking Process
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Complicated booking processes create friction that drives potential patients away. Simplify appointment scheduling by minimizing required steps, reducing form fields, providing clear instructions, and offering multiple booking methods. Implement online booking systems prominently displayed on every page, accessible with minimal clicks, and functional on all devices.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Optimize booking forms by requesting only essential information upfront—name, contact details, preferred date/time, and reason for visit. Collect additional information after appointments are confirmed. Display real-time availability, provide instant confirmation, and send automated reminders. Each eliminated friction point increases conversion rates by reducing abandonment.
            </p>

            <h3 className="text-xl sm:text-2xl font-bold text-[#19354a] mb-4 mt-6">
              Booking Optimization Strategies
            </h3>

            <ul className="list-disc list-inside text-gray-900 text-base leading-relaxed mb-6 space-y-2 ml-4 text-justify">
              <li>Reduce form fields to absolute minimum required</li>
              <li>Display clear progress indicators for multi-step processes</li>
              <li>Offer multiple booking methods (online, phone, text)</li>
              <li>Provide real-time availability and instant confirmation</li>
              <li>Enable mobile-optimized booking with autofill features</li>
              <li>Allow new patient and existing patient pathways</li>
            </ul>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Building Trust Through Design and Content
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Trust represents the foundation of healthcare decision-making. Patients schedule appointments only when confident in provider qualifications, practice reputation, and service quality. Display trust signals prominently including professional credentials, certifications, awards, patient testimonials, before-and-after photos (with consent), and security badges.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Showcase provider expertise through detailed bios, educational backgrounds, specializations, and professional affiliations. Feature authentic patient reviews and ratings from multiple platforms. Display professional photography, modern facilities, and advanced technology. Transparent pricing information, clear policies, and HIPAA compliance statements further build confidence and reduce booking hesitation.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Creating Compelling Calls-to-Action
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Effective calls-to-action (CTAs) guide visitors toward conversion with clear, compelling messaging and prominent placement. Use action-oriented language emphasizing benefits and outcomes—"Schedule Your Consultation," "Book Same-Day Appointments," "Get Expert Care Today." Create visual contrast with colors, buttons, and whitespace that draw attention without overwhelming.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Position CTAs strategically throughout pages—above fold, after service descriptions, within content sections, and at page conclusions. Repeat CTAs appropriately for longer pages without excessive repetition. Test different CTA variations including button colors, text, placement, and size. Data-driven optimization identifies highest-performing combinations for maximum conversion impact.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Improving Page Speed and Mobile Experience
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Page speed directly impacts conversion rates—every second of delay reduces conversions by 7%. Optimize images, minimize code, leverage caching, and use content delivery networks to achieve sub-2-second load times. Monitor Core Web Vitals including Largest Contentful Paint, First Input Delay, and Cumulative Layout Shift to ensure optimal performance.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              With 70% of healthcare searches occurring on mobile devices, mobile optimization proves essential for conversion success. Implement responsive design ensuring perfect display across all screen sizes. Optimize touch targets for easy interaction, simplify navigation for smaller screens, and prioritize mobile-specific features like click-to-call buttons and location-based services.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Reducing Form Abandonment
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Form abandonment rates average 67%, representing massive conversion opportunity. Reduce abandonment by minimizing required fields, using clear labels, providing helpful error messages, and saving progress automatically. Implement smart defaults, autofill capabilities, and inline validation providing immediate feedback without frustrating users.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Address privacy concerns explicitly with security badges, HIPAA compliance statements, and privacy policy links near forms. Explain why information is needed and how it will be used. Consider progressive disclosure—collecting basic information initially and requesting additional details after initial engagement. Each improvement reduces friction and increases completion rates.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              A/B Testing and Continuous Optimization
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Systematic A/B testing drives continuous conversion improvement by comparing variations of elements including headlines, CTAs, images, forms, layouts, and content. Test one element at a time to isolate impact, run tests until statistical significance, and implement winning variations. Regular testing compounds improvements over time, gradually optimizing entire conversion funnel.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Track conversion metrics using Google Analytics, heatmaps, session recordings, and form analytics. Identify where visitors drop off, what elements attract attention, and which pathways lead to conversion. Use data insights to prioritize optimization efforts, focusing on high-impact opportunities. Successful conversion optimization requires ongoing testing, measurement, and refinement based on user behavior data.
            </p>

            {/* FAQ SECTION */}
            <div className="mt-12 mb-12">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-8 text-center">
                Frequently Asked Questions (FAQs)
              </h2>

              <div className="space-y-4">
                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      What's a good conversion rate for healthcare websites?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Healthcare website conversion rates typically range from 2-5% for appointment bookings. However, "good" rates vary by specialty, location, and competition. Focus on continuous improvement rather than absolute benchmarks. Specialty practices and established providers often achieve 5-10% conversion rates with optimized websites.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How do I know what to test first?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Start with high-traffic, high-impact pages and elements. Test booking forms first, then homepage CTAs, service pages, and contact methods. Use analytics to identify pages with high traffic but low conversion. Prioritize tests with potential for significant impact over minor tweaks to low-traffic pages.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      Should I display pricing on my website?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Transparency generally improves conversion rates by qualifying leads and building trust. Display pricing ranges, starting prices, or service tiers when possible. For complex procedures requiring personalized quotes, explain why pricing varies and offer free consultations. Hiding all pricing information often reduces conversions.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How important are patient testimonials for conversion?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Patient testimonials significantly impact conversion rates by providing social proof and building trust. Display authentic reviews prominently, include patient photos (with permission), use video testimonials when possible, and aggregate ratings from multiple platforms. Reviews addressing common concerns prove especially effective.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How can Docmize help optimize conversion rates?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Docmize specializes in healthcare website conversion optimization with proven strategies for medical practices. We conduct comprehensive conversion audits, implement booking optimization, perform A/B testing, enhance trust signals, improve page speed, and provide ongoing optimization. Our data-driven approach maximizes patient acquisition from existing traffic.
                  </div>
                </details>
              </div>
            </div>

          </motion.div>
        </div>
      </section>

      {/* RELATED BLOGS SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl font-bold text-[#19354a] mb-8"
          >
            Related Blog
          </motion.h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {relatedBlogs.map((blog, index) => (
              <motion.article
                key={blog.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300"
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={blog.image} 
                    alt={blog.title}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-[#19354a] mb-3 line-clamp-2">
                    {blog.title}
                  </h3>
                  <div className="flex items-center gap-2 text-sm text-gray-500 mb-4">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                    </svg>
                    <span>{blog.date}</span>
                  </div>
                  <Link 
                    to="/blog"
                    className="inline-flex items-center gap-2 text-[#39a5d3] font-semibold hover:gap-3 transition-all"
                  >
                    Read More
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MedicalWebsiteFeatures;